import { render } from "./fleet.cattle.io.policy.vue?vue&type=template&id=06e6e1b6&scoped=true"
import script from "./fleet.cattle.io.policy.vue?vue&type=script&lang=js"
export * from "./fleet.cattle.io.policy.vue?vue&type=script&lang=js"

import "./fleet.cattle.io.policy.vue?vue&type=style&index=0&id=06e6e1b6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e6e1b6"]])

export default __exports__